import React, { useEffect, useRef, useState } from "react";
import "./Login.css";
import { InputText } from "primereact/inputtext";
import { GFNButton } from "../ui/GFNButton";
import { Link, useNavigate } from "react-router-dom";
import { LoginService } from "../services/LoginService";
import { STARTER_API } from "../ApiNames";
import { Toast } from "primereact/toast";

const imageName = require("./../assets/img/gfn.png");

interface LoginData {
  username: string;
  password: string;
  usertype: string;
  checked: any;
}

const Login = () => {
  useEffect(() => {
    const currentURL = window.location.href;
    // const currentURL = "https://devrct.gearforneed.com/#/login";
    // const currentURL = "https://gearforneed.com/#/login";
    const Locationsurls = currentURL.match(/(https?:\/\/[^\/]*\.com)/) as any;

    window.sessionStorage.setItem("Locationsurls", Locationsurls[0]);
    const splitPath = currentURL.split("://")[1].split(".");
    const firstPart = splitPath[0];
    const threeChar = firstPart.slice(0, 3);
    const isDevReactPath = threeChar.includes("dev");
    const isValReactPath = threeChar.includes("val");
    const isReactPath = currentURL.includes("https://gearforneed.com");

    let baseDomain;
    if (isDevReactPath) {
      baseDomain = `https://devapi.gearforneed.com/member/gfn-api`;
    } else if (isValReactPath) {
      baseDomain = `https://valapi.gearforneed.com/member/gfn-api`;
    } else if (isReactPath) {
      baseDomain = `http://api.gearforneed.com/member/gfn-api`;
    } else {
      // baseDomain = "http://192.168.1.197/Finalprod/API/gfn/member/gfn-api";
      baseDomain = `http://api.gearforneed.com/member/gfn-api`;
    }

    window.sessionStorage.setItem("baseDomain", baseDomain as any);

    let apiRoot;
    if (isDevReactPath) {
      apiRoot = `https://devapi.gearforneed.com`;
    } else if (isValReactPath) {
      apiRoot = `https://valapi.gearforneed.com`;
    } else if (isReactPath) {
      apiRoot = `http://api.gearforneed.com`;
    } else {
      // baseDomain = "http://192.168.1.197/Finalprod/API/gfn";
      apiRoot = `http://api.gearforneed.com`;
    }

    window.sessionStorage.setItem("apiRoot", apiRoot as any);
  }, []);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userData, setUserData] = useState<LoginData[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const navigate = useNavigate();
  const toast = useRef<Toast | null>(null);

  const validateEmail = (value: string) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, username: "Invalid email format" }));
    } else {
      setErrors((prev) => ({ ...prev, username: "" }));
    }
    setUsername(value);
  };

  const validatePassword = (value: string) => {
    if (!/^(?=.*[A-Z])(?=.*\d{4,})(?=.*[a-z]{4,}).{8,}$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        password:
          "Must contain 1 uppercase, 4 lowercase, 4 digits & be at least 8 characters",
      }));
    } else {
      setErrors((prev) => ({ ...prev, password: "" }));
    }
    setPassword(value);
  };

  const isFormValid =
    username && password && Object.values(errors).every((error) => !error);

  useEffect(() => {
    const handleNavigation = () => {
      if (sessionStorage.getItem("auth_code") === "YES") {
        navigate("/");
      } else if (userData.length > 0) {
        switch (userData[0]?.usertype) {
          case "fundmanager":
            navigate("/fdashboard");
            break;
          case "donor":
            navigate("/ddashboard");
            break;
          case "organisation":
            navigate("/odashboard");
            break;
          case "admin":
            navigate("/adashboard");
            break;
          default:
            break;
        }
      }
    };
    handleNavigation();
  }, [userData, navigate]);

  const handleLogin = async () => {
    try {
      const payload = { username, password };
      const apiname = STARTER_API.STARTER_LOGIN;
      const data = await LoginService.getData(apiname, payload);
      setUserData(data);

      if (data && data == "Please Check your credentials") {
        toast.current?.show({
          severity: "info",
          summary: "info",
          detail: "Please Check your credentials",
          life: 3000,
        });
      }

      if (data && data == "Please Activate your Account") {
        toast.current?.show({
          severity: "info",
          summary: "info",
          detail: "Please Activate your Account",
          life: 3000,
        });
      }

      const userid = data[0]?.userid;
      const uid = data[0]?.uid;
      const photo = data[0]?.photo;
      const usertype = data[0]?.usertype;

      window.sessionStorage.setItem("userid", userid);
      window.sessionStorage.setItem("uid", uid);
      window.sessionStorage.setItem("photo", photo);
      window.sessionStorage.setItem("usertype", usertype);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Sorry",
        detail: "Your Credentials Do not Match",
        life: 3000,
      });
      setUserData([]);
    }
  };

  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/login.php`;

  const openWindow = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    targetUrl: string
  ): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      "newwindow",
      "width=1000,height=1000,noopener,noreferrer"
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="main-body">
      <div className="login-help-bar">
        <a
          title="help"
          onClick={(e) => openWindow(e, IUrl)}
          className="app-help-link"
        >
          Help for this Page
          <i className="pi pi-question-circle"></i>
        </a>
      </div>

      <div className="login-page">
        <div className="login-shell">
          <aside className="login-hero">
            <div className="login-brand">
              <img src={imageName} alt="GearForNeed logo" />
              <h1>Support people in need with confidence.</h1>
              <p>
                Access the same workflows, forms, and dashboards in a cleaner,
                more focused experience built on PrimeReact styling.
              </p>
            </div>
            <div className="login-feature-list">
              <div className="login-feature">
                <i className="pi pi-shield"></i>
                <span>Existing authentication and roles remain unchanged.</span>
              </div>
              <div className="login-feature">
                <i className="pi pi-bolt"></i>
                <span>Sharper layout, clearer hierarchy, and faster scanning.</span>
              </div>
              <div className="login-feature">
                <i className="pi pi-mobile"></i>
                <span>Responsive presentation for desktop, tablet, and mobile.</span>
              </div>
            </div>
          </aside>

          <section className="login-card">
            <div className="login-card-inner">
              <div className="login-card-header">
                <h2>Sign in</h2>
                <p>Use your existing GearForNeed account to continue.</p>
              </div>

              <div className="login-form">
                <div className="login-field">
                  <label htmlFor="username">Email</label>
                  <InputText
                    id="username"
                    type="text"
                    placeholder="Email address"
                    className={errors.username ? "p-invalid" : ""}
                    value={username}
                    onChange={(e) => validateEmail(e.target.value)}
                    data-testid="email-input"
                  />
                  {errors.username && (
                    <small className="p-error">{errors.username}</small>
                  )}
                </div>

                <div className="login-field">
                  <label htmlFor="password">Password</label>
                  <InputText
                    id="password"
                    type="password"
                    placeholder="Password"
                    className="w-full"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="password-input"
                  />
                  {errors.password && (
                    <small className="p-error">{errors.password}</small>
                  )}
                </div>

                <div className="login-links-row">
                  <Link to="/forgetpassword" className="login-link">
                    Forgot your password?
                  </Link>
                </div>

                <GFNButton
                  label="Login"
                  onClick={handleLogin}
                  icon="pi pi-user"
                  buttonType="primary"
                  fullWidth
                  disabled={!isFormValid}
                  testId="login-btn"
                />
              </div>

              <div className="login-register">
                <span>Don't have an account?</span>
                <Link
                  to="/register"
                  className="login-link"
                  data-testid="register-link"
                >
                  Register a new membership
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default Login;
